export default "__VITE_ASSET__CYBRAoU9__"